/**
 * The backend's line-crossing `direction` as the three values the UI reasons
 * about. Case- and whitespace-insensitive (ENG-1317): the Django admin dropdown
 * writes `L2R`/`R2L`/`BOTH`, this UI writes `l2r`/`r2l`/`both`, and the model
 * validates nothing. A strict `=== "l2r"` comparison sent every uppercase row
 * down the R2L branch, so `L2R` rendered as R2L and `BOTH` as a single arrow —
 * and saving the page wrote the wrong value back. Unknown values render as
 * "Both", which is also how the connector treats them.
 */
export type BackendLineDirection = "l2r" | "r2l" | "both";

export const normalizeBackendDirection = (
  raw: unknown
): BackendLineDirection => {
  const key = String(raw ?? "both")
    .trim()
    .toLowerCase();
  if (key === "l2r" || key === "left_to_right") return "l2r";
  if (key === "r2l" || key === "right_to_left") return "r2l";
  return "both";
};
